export class AreaJaggaerModel {
  public role: any;
  public notes: string;
}
